import { ProLightDiagramCells, ProLightDiagramCellsProps } from '@nexelem/icons/ProLightDiagramCells';
import { styled, Theme } from '@nexelem/deprecated-theme';

export const StyledProLightDiagramCells = styled(ProLightDiagramCells)(({ theme }) => {
  const { spacing } = theme as Theme;
  return {
    '&&&': {
      paddingRight: 0,
      marginRight: spacing(2),
    },
  };
});

export const ProLightDiagramCellsRation = (props: ProLightDiagramCellsProps) => (
  <StyledProLightDiagramCells {...props} iconProps={{ rotation: 90 }} />
);

ProLightDiagramCellsRation.displayName = 'ProLightDiagramCellsRation';
